/**
 * ERP returns "0001-01-01" when date fields are unset.
 */
export const isInvalidErpDate = (dateString?: string | null): boolean => {
  if (!dateString || dateString.trim() === "") {
    return true;
  }
  if (dateString === "0001-01-01T00:00:00") {
    return true;
  }
  return /^0001-01-01/.test(dateString.trim());
};

export const pickFirstValidErpDate = (
  ...values: Array<string | undefined | null>
): string | undefined => {
  for (const value of values) {
    if (
      value !== undefined &&
      value !== null &&
      value !== "" &&
      !isInvalidErpDate(value)
    ) {
      return value;
    }
  }
  return undefined;
};
